import { ReactElement, useCallback } from 'react';

import { Button, GetAppIcon } from '@breathelife/mui';
import { downloadFileFromBlob } from '@breathelife/file-helpers';

type Props = {
  name: string;
  disabled: boolean;
  data?: string;
  fileName: string;
};

export function ExportEntityButton({ name, disabled, data, fileName }: Props): ReactElement {
  const onExport = useCallback(() => {
    if (!data) return;

    const dataBlob = new Blob([data], { type: 'application/json' });
    downloadFileFromBlob(dataBlob, fileName);
  }, [data, fileName]);

  return (
    <Button disabled={disabled} variant='outlined' color='primary' onClick={onExport} startIcon={<GetAppIcon />}>
      {name}
    </Button>
  );
}
